import { Calendar } from "lucide-react";
import { useMyLegalCases } from "@/api/portal";
import { LEGAL_CASE_STATUS_LABEL, LegalCaseStatus } from "@/api/legal";

const STATUS_STYLE: Record<LegalCaseStatus, string> = {
  ACTIVO: "bg-blue-100 text-blue-700",
  SUSPENDIDO: "bg-amber-100 text-amber-700",
  ARCHIVADO: "bg-gray-100 text-gray-500",
  TERMINADO: "bg-green-100 text-green-700",
};

export default function PortalLegalCasesPage() {
  const { data, isLoading } = useMyLegalCases({ pageSize: 100 });
  const legalCases = data?.data ?? [];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Jurídico</h1>
        <p className="text-sm text-gray-500">Procesos legales que la firma gestiona para usted.</p>
      </div>

      <div className="card overflow-hidden">
        {isLoading && <p className="p-6 text-sm text-gray-400">Cargando...</p>}
        {!isLoading && legalCases.length === 0 && (
          <p className="p-10 text-center text-sm text-gray-400">No tiene procesos jurídicos registrados.</p>
        )}
        {!isLoading && legalCases.length > 0 && (
          <div className="divide-y divide-gray-100">
            {legalCases.map((legalCase) => (
              <div key={legalCase.id} className="p-4">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-medium text-gray-900">{legalCase.title}</p>
                    <p className="mt-0.5 text-xs text-gray-500">
                      {legalCase.caseType || "Sin tipo"}
                      {legalCase.caseNumber && ` · Rad. ${legalCase.caseNumber}`}
                      {legalCase.court && ` · ${legalCase.court}`}
                    </p>
                  </div>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLE[legalCase.status]}`}>
                    {LEGAL_CASE_STATUS_LABEL[legalCase.status]}
                  </span>
                </div>
                {legalCase.nextHearingDate && (
                  <p className="mt-2 inline-flex items-center gap-1 text-xs text-gray-500">
                    <Calendar size={12} /> Próxima audiencia: {legalCase.nextHearingDate}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
